import React, { useEffect, useState } from "react";
import ModalInDrawer from "../ui/ModalInDrawer";
import axios from "axios";
import { BACKEND } from "../../config/configEnvs";
import SelectInput from "../ui/SelectInput";
import { toast } from "react-toastify";
const TransferirCotizacionDialog = ({
  open,
  onClose,
  updateCotizacionLocally,
  data,
  tipoDescuento
}) => {

  const [trabajadoresList, setTrabajadoresList] = useState([]);

  useEffect(() => {
    getTrabajadores();

    if (data.cotizador) {
      setActiveTrabajador(data.cotizador.id);
    }
  }, [data]);

  const getTrabajadores = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/trabajadores?limit=0&where[activo][equals]=true`)
      const sellers = response.data.docs.filter((w) => w.area.toUpperCase() === "ADMINISTRACION" || w.area.toUpperCase() === "COMERCIAL")
      setTrabajadoresList(sellers)

    } catch (e) {
      return false
    }
  };

  const [activeTrabajador, setActiveTrabajador] = useState(null);

  const actualizar = async () => {
    if (!activeTrabajador) {
      toast.warning("Selecciona un vendedor", {
        style: { zIndex: 9999 },
      });
      return;
    }
    await axios
      .put(`${BACKEND}/api/cotizaciones/${data?.id}`, {
        cotizador: activeTrabajador,
        tipoDescuento:tipoDescuento
      })
      .then(({ data }) => {
        updateCotizacionLocally(data.doc);
      })

      .then(() => {
        toast.success("Cotización actualizada exitosamente", {
          style: { zIndex: 9999 },
          position: "top-right",
        });
        onClose();
      })
      .catch((e) => {
        toast.error("Error al actualizar la cotizacion", {
          style: { zIndex: 9999 },
        });
        console.log(e);
      });
  };

  return (
    <ModalInDrawer
      activeModal={open}
      onClose={onClose}
      title="Transferir cotización"
      centered
    >
      <SelectInput
        title={"Seleccionar trabajador"}
        value={activeTrabajador}
        setValue={(e) => setActiveTrabajador(e)}
        options={trabajadoresList.map((e) => ({
          value: e.id,
          label: `${e.name} - ${e?.puesto}`,
          id: e.id,
        }))}
      />

      <div className=" mt-10 flex justify-center">
        <button
          onClick={actualizar}
          type="button"
          className="text-white bg-[#4285F4] hover:bg-[#4285F4]/90 focus:ring-4 focus:outline-none focus:ring-[#4285F4]/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center  me-2 mb-2"
        >
          Transferir
        </button>
      </div>
    </ModalInDrawer>
  );
};

export default TransferirCotizacionDialog;
